import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "rask-toggle-list",
    templateUrl: "./toggle-list.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./toggle-list.component.scss"]
})
export class ToggleListComponent {

}
